import { FC } from 'react';
import { Logo } from './Logo';
import { SidebarMenu } from './Menu';

const Sidebar: FC = () => (
    <div className="sidebar">
        <Logo />
        <SidebarMenu />
    </div>
);

export { Sidebar };
